import AppHeaderAux from './AppHeaderAux';
import AppHeaderBrand from './AppHeaderBrand';
import AppHeaderRoot from './AppHeaderRoot';
import AppHeaderSearch from './AppHeaderSearch';

export type { AppHeaderRootProps } from './AppHeaderRoot';
export type { AppHeaderBrandProps } from './AppHeaderBrand';
export type { AppHeaderSearchProps } from './AppHeaderSearch';
export type { AppHeaderAuxProps } from './AppHeaderAux';

export const AppHeader = {
  Root: AppHeaderRoot,
  Brand: AppHeaderBrand,
  Search: AppHeaderSearch,
  Aux: AppHeaderAux,
};
